import * as React from "react";

export const EngagementVector = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={153} height={137} fill="none" {...props}>
    <path
      fill="#DAEEF7"
      d="M132.407 97.417H71.145a3.6 3.6 0 0 0-3.598 3.601v25.521a3.6 3.6 0 0 0 3.599 3.599h6.362c-.37 2.81-.853 6.84-.588 6.84.266 0 3.37-4.24 5.236-6.84h50.251a3.6 3.6 0 0 0 3.6-3.599v-25.521a3.601 3.601 0 0 0-3.6-3.6Z"
      opacity={0.3}
      style={{
        mixBlendMode: "multiply",
      }}
    />
    <path
      fill="#FEB546"
      d="M135.337 90.634H74.074a3.598 3.598 0 0 0-3.599 3.599v25.521a3.6 3.6 0 0 0 3.599 3.599h6.362c-.37 2.81-.853 6.84-.588 6.84.266 0 3.37-4.24 5.236-6.84h50.253a3.603 3.603 0 0 0 2.542-1.054 3.603 3.603 0 0 0 1.054-2.542V94.236a3.616 3.616 0 0 0-1.052-2.546 3.604 3.604 0 0 0-2.544-1.056Z"
    />
    <path
      fill="#fff"
      d="M88.716 113.466a9.022 9.022 0 0 0 0-12.76 9.022 9.022 0 0 0-12.76 0 9.022 9.022 0 0 0 0 12.76 9.023 9.023 0 0 0 12.76 0Z"
    />
    <path fill="#FFC0BB" d="M83.763 111.631h-2.649v2.646h2.649v-2.646Z" />
    <path fill="#F99893" d="M83.764 113.218v-1.587h-2.65v1.35c.57.305 1.415.482 2.65.237Z" />
    <path
      fill="#FFC0BB"
      d="M87.941 106.897a.963.963 0 0 0-.448-.088.971.971 0 0 0-.44.124 4.718 4.718 0 0 0-9.435 0 .971.971 0 0 0-.44-.124.963.963 0 0 0-.448.088c-.53.261-.695 1.01-.367 1.671.328.662 1.02.986 1.552.725a.843.843 0 0 0 .198-.136c.302 2.158 2.115 3.776 4.229 3.745 2.114.031 3.918-1.587 4.228-3.745.06.055.127.101.2.136.53.261 1.224-.063 1.552-.725.328-.661.15-1.41-.38-1.671Z"
    />
    <path
      fill="#07085B"
      d="M79.11 101.185s1.329-1.125 4.352-.944c3.023.182 3.597 1.76 3.776 4.011l-.177 2.681s-.785-.808-1.812-3.045c0 0-1.693 1.899-2.43 1.674-.737-.225.28-1.592.28-1.592s-3.45 2.966-5.478 2.963c0 0-1.074-3.474.435-4.747 0 0-1.137.055-1.198-.169-.06-.223.542-.557 1.634-.432 0 0-.777-1.52-.342-1.679.434-.158.96 1.279.96 1.279Z"
    />
    <path
      fill="#fff"
      d="M84.07 109.98c-.117.523-.716.935-1.45.958-.734.022-1.36-.352-1.51-.867l2.96-.091ZM130.02 97.988H94.818a.355.355 0 0 0-.354.355v.858c0 .196.158.355.354.355h35.202a.355.355 0 0 0 .355-.355v-.858a.355.355 0 0 0-.355-.355ZM102.59 102.126h-7.772a.355.355 0 0 0-.354.355v.858c0 .196.158.355.354.355h7.772a.354.354 0 0 0 .354-.355v-.858a.354.354 0 0 0-.354-.355ZM130.021 102.126h-23.52a.355.355 0 0 0-.355.355v.858c0 .196.159.355.355.355h23.52a.355.355 0 0 0 .355-.355v-.858a.355.355 0 0 0-.355-.355ZM112.661 106.264H94.818a.355.355 0 0 0-.354.355v.857c0 .196.158.355.354.355h17.843a.355.355 0 0 0 .355-.355v-.857a.355.355 0 0 0-.355-.355ZM130.02 106.264h-13.936a.355.355 0 0 0-.355.355v.857c0 .196.159.355.355.355h13.936a.355.355 0 0 0 .355-.355v-.857a.355.355 0 0 0-.355-.355ZM130.02 110.4H94.818a.355.355 0 0 0-.354.355v.858c0 .196.158.355.354.355h35.202a.355.355 0 0 0 .355-.355v-.858a.355.355 0 0 0-.355-.355Z"
    />
    <path
      fill="#DAEEF7"
      d="M88.21 39.475H18.045a4.39 4.39 0 0 0-4.389 4.388V72.82a4.388 4.388 0 0 0 4.389 4.389h55.24c2.235 3.118 6.29 8.706 6.645 8.706.334 0-.311-5.277-.766-8.706h9.043a4.388 4.388 0 0 0 4.389-4.389V43.863a4.39 4.39 0 0 0-4.386-4.388Z"
      opacity={0.3}
      style={{
        mixBlendMode: "multiply",
      }}
    />
    <path
      fill="#FF5B7E"
      d="M85.312 31.962H15.147a4.388 4.388 0 0 0-4.389 4.388V65.31a4.388 4.388 0 0 0 4.389 4.388h55.242c2.235 3.12 6.288 8.706 6.645 8.706.356 0-.31-5.276-.765-8.706h9.042a4.39 4.39 0 0 0 4.391-4.388V36.353a4.388 4.388 0 0 0-4.39-4.391Z"
    />
    <path
      fill="#fff"
      d="M30.065 60.982c5.604-2.346 8.247-8.791 5.9-14.396-2.345-5.605-8.79-8.247-14.395-5.901-5.605 2.345-8.247 8.79-5.901 14.395s8.79 8.247 14.396 5.902Z"
    />
    <path
      fill="#040744"
      d="M20.085 51.12s-1.09-4.476 1.51-6.153c2.6-1.676 5.373-2.06 7.27-1.094 2.629 1.339 3.709 4.957 2.869 6.958l-6.968-1.752-4.681 2.04Z"
    />
    <path fill="#FFC0BB" d="M27.558 56.375h-3.23V59.6h3.23v-3.226Z" />
    <path fill="#F99893" d="M27.558 58.308v-1.933h-3.23v1.645c.697.37 1.726.587 3.23.288Z" />
    <path
      fill="#FFC0BB"
      d="M32.652 50.602a1.208 1.208 0 0 0-1.083.042 5.541 5.541 0 0 0-5.75-5.739 5.545 5.545 0 0 0-5.752 5.739 1.208 1.208 0 0 0-1.083-.042c-.646.318-.847 1.23-.453 2.037.394.806 1.246 1.208 1.892.885.089-.044.17-.1.243-.166.37 2.63 2.567 4.603 5.148 4.566 2.58.037 4.777-1.936 5.148-4.566.072.067.154.123.242.166.646.318 1.493-.077 1.892-.885.399-.808.203-1.719-.444-2.037Z"
    />
    <path
      fill="#fff"
      d="M27.938 54.36c-.142.64-.872 1.14-1.767 1.168-.896.027-1.662-.43-1.837-1.057l3.604-.11Z"
    />
    <path
      fill="#040744"
      d="M20.067 50.644s4.228-1.28 6.076-3.419c0 0-.522 2.576-.913 2.987.124.083 4.228-1.91 4.78-3.75.55-1.839-4.187-2.499-4.187-2.499s-1.628.692-1.71.734c-.08.042-1.607.219-1.783.604-.228.508-1.304.553-1.304.553l-.681 1.415-.476 1.489.198 1.886Z"
    />
    <path
      fill="#040744"
      d="M16.602 44.82c.935.377 2.013.55 3.13.206 2.469-.755 3.446-.463 3.776-.278a.8.8 0 0 0 .648.085c.243-.082.47-.302.399-.856 0 0 .098-2.346-1.912-3.68a11.024 11.024 0 0 0-6.04 4.524Z"
    />
    <path
      fill="#FEB546"
      d="M21.912 44.667a.21.21 0 0 1-.01-.242.209.209 0 0 1 .061-.06c.413-.27 1.473-.88 2.746-.946a.208.208 0 0 1 .219.21.21.21 0 0 1-.2.209c-1.162.06-2.159.634-2.535.879a.208.208 0 0 1-.281-.05Z"
    />
    <path
      fill="#fff"
      d="M53.269 41.354H39.398a.433.433 0 0 0-.434.433v1.045c0 .24.195.433.434.433h13.87c.24 0 .434-.194.434-.433v-1.045a.433.433 0 0 0-.433-.433ZM48.486 46.397h-9.088a.433.433 0 0 0-.434.434v1.045c0 .24.195.433.434.433h9.088c.24 0 .433-.194.433-.433V46.83a.433.433 0 0 0-.433-.434ZM62.453 46.397H51.07a.433.433 0 0 0-.434.434v1.045c0 .24.194.433.434.433h11.383c.24 0 .434-.194.434-.433V46.83a.433.433 0 0 0-.434-.434ZM80.685 41.354H56.58a.433.433 0 0 0-.434.433v1.045c0 .24.194.433.434.433h24.106c.24 0 .433-.194.433-.433v-1.045a.433.433 0 0 0-.433-.433ZM80.685 56.286H39.398a.433.433 0 0 0-.434.433v1.045c0 .24.195.434.434.434h41.287c.24 0 .433-.194.433-.434V56.72a.433.433 0 0 0-.433-.433ZM60.307 51.443H39.398a.433.433 0 0 0-.434.433v1.045c0 .24.195.434.434.434h20.91c.239 0 .433-.194.433-.434v-1.045a.433.433 0 0 0-.434-.433ZM80.685 51.443H64.36a.433.433 0 0 0-.433.433v1.045c0 .24.194.434.434.434h16.324c.24 0 .433-.194.433-.434v-1.045a.433.433 0 0 0-.433-.433Z"
    />
    <path
      fill="#FF5B7E"
      d="M48 117s-.683 6.548-6 7.001c5.317.454 6 6.999 6 6.999s.683-6.545 6-6.999c-5.317-.453-6-7.001-6-7.001Z"
    />
    <path
      fill="#02CCC0"
      d="M147.72 87.395s-.533 5.243-4.671 5.605c4.138.363 4.671 5.607 4.671 5.607s.532-5.244 4.669-5.607c-4.137-.362-4.669-5.605-4.669-5.605ZM4.67 24.058S4.137 29.301 0 29.664c4.138.362 4.67 5.607 4.67 5.607s.53-5.245 4.669-5.607c-4.138-.363-4.67-5.606-4.67-5.606Z"
    />
    <path
      fill="#FEB546"
      d="M109.997 60s-.681 7.483-5.997 7.999c5.316.518 5.997 8.001 5.997 8.001s.685-7.483 6.003-7.999c-5.318-.518-6.003-8.001-6.003-8.001ZM23.999 0S23.43 6.079 19 6.5c4.43.421 4.999 6.5 4.999 6.5s.57-6.079 5.001-6.5C24.57 6.079 23.999 0 23.999 0Z"
    />
  </svg>
);
